<template>
    <div>
        <b-loading :active="loading" :is-full-page="false" />
        <prd-empty-state
            v-if="!loading && historico.length === 0"
            icon="history"
            title="Histórico ainda vazio"
            description="As alterações importantes aparecerão aqui."
        />
        <div v-else class="prd-timeline">
            <div v-for="item in historico" :key="item.id" class="prd-timeline-item">
                <span class="prd-timeline-dot" />
                <div class="prd-timeline-content">
                    <div class="is-flex is-justify-content-space-between is-align-items-center">
                        <strong>{{ titulo(item) }}</strong>
                        <small class="has-text-grey">{{ formatarData(item.dataHora) }}</small>
                    </div>
                    <p v-if="item.usuarioNome" class="is-size-7 has-text-grey">por {{ item.usuarioNome }}</p>
                    <p v-if="item.descricao" class="prd-timeline-description">{{ item.descricao }}</p>
                    <p v-if="item.valorAnterior || item.valorInformado" class="is-size-7">
                        <span v-if="item.valorAnterior">De: {{ item.valorAnterior }}</span>
                        <span v-if="item.valorInformado" class="ml-2">Para: {{ item.valorInformado }}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import prdEmptyState from './prdEmptyState.vue'

export default {
    name: 'PrdHistorico',
    components: { prdEmptyState },
    props: {
        entidade: { type: String, required: true },
        entidadeId: { type: Number, required: true },
        unidadeId: { type: Number, required: true },
    },
    data() {
        return { loading: false, historico: [] }
    },
    created() {
        this.carregar()
    },
    methods: {
        async carregar() {
            this.loading = true
            try {
                const res = await http.get(`/api/prd/${this.entidade}/${this.entidadeId}/historico?unidadeId=${this.unidadeId}`)
                this.historico = res.data || []
            } finally {
                this.loading = false
            }
        },
        titulo(item) {
            return item.valorInformado || (item.acao || '').replace(/^Prd/, '') || 'Movimentação'
        },
        formatarData(valor) {
            return valor ? new Date(valor).toLocaleString('pt-BR') : ''
        },
    },
}
</script>

<style scoped>
.prd-timeline {
    padding: 0.5rem 0.25rem 0.5rem 1rem;
}
.prd-timeline-item {
    position: relative;
    border-left: 2px solid #e7edf3;
    padding: 0 0 1.25rem 1.25rem;
}
.prd-timeline-item:last-child {
    border-left-color: transparent;
}
.prd-timeline-dot {
    position: absolute;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #3273dc;
    left: -6px;
    top: 0.35rem;
    box-shadow: 0 0 0 4px #eef5ff;
}
.prd-timeline-content {
    background: #f8fafc;
    border-radius: 10px;
    padding: 0.75rem 1rem;
}
.prd-timeline-description {
    margin-top: 0.35rem;
    color: #526275;
    white-space: pre-line;
}
</style>
